const beerList = [
  {
    type: "Draft",
    list: [
      {
        name: "Ghost Train Kettle Sour",
        glass: "$7.00",
        pitcher: "$27.00",
      },
      {
        name: "Stella",
        glass: "$6.00",
        pitcher: "$23.00",
      },
      {
        name: "Bud Light",
        glass: "$3.50",
        pitcher: "$13.00",
      },
      {
        name: "Sweetwater 420-Extra Pale Ale",
        glass: "$6.50",
        pitcher: "$24.00",
      },
      {
        name: "Goose Island German Kolsch",
        glass: "$4.50",
        pitcher: "$17.00",
      },
      {
        name: "Shock Top Belgian White",
        glass: "$4.00",
        pitcher: "$15.00",
      },
      {
        name: "Wicked Weed Pernicious IPA",
        glass: "$6.50",
        pitcher: "$25.00",
      },
      {
        name: "Stiegl Radler, Salzburg, Australia Male",
        glass: "$6.75",
        pitcher: "$26.00",
      },
      {
        name: "Main Channel Amber",
        glass: "$6.75",
        pitcher: "$26.00",
      },
      {
        name: "Singing River IPA",
        glass: "$5.50",
        pitcher: "$20.00",
      },
      {
        name: "Miller Lite",
        glass: "$3.50",
        pitcher: "$13.00",
      },
      {
        name: "Yuengling",
        glass: "$3.50",
        pitcher: "$13.00",
      },
      {
        name: "Blood Orange Berliner Weisse",
        glass: "$7.00",
        pitcher: "$27.00",
      },
      {
        name: "Blue Moon Belgium White Ale",
        glass: "$5.50",
        pitcher: "$20.00",
      },
      {
        name: "Truly Seltzer",
        glass: "$6.50",
        pitcher: "$24.00",
      },
      {
        name: "Coors Light",
        glass: "$3.50",
        pitcher: "$13.00",
      },
      {
        name: "New Belgium Fat Tire",
        glass: "$6.50",
        pitcher: "$25.00",
      },
      {
        name: "Dragon's Milk Bourbon Barrel Aged Stout",
        glass: "$9.50",
        pitcher: "N/A", // Price for pitcher not clearly mentioned
      },
      {
        name: "New Belgium (Juicy Haze) IPA",
        glass: "$6.75",
        pitcher: "$24.00",
      },
    ],
  },
  {
    type: "Bottle",
    list: [
      {
        name: "Bud",
        price: "$4.00",
      },
      {
        name: "Bud Light",
        price: "$4.00",
      },
      {
        name: "Coors Light",
        price: "$4.00",
      },
      {
        name: "Miller Lite",
        price: "$4.00",
      },
      {
        name: "Corona, Corona Light",
        price: "$5.50",
      },
      {
        name: "Michelob Ultra",
        price: "$4.50",
      },
      {
        name: "Guinness Can",
        price: "$7.25",
      },
      {
        name: "Pabst Blue Ribbon Can",
        price: "$3.25",
      },
      {
        name: "Highlife",
        price: "$3.50",
      },
      {
        name: "White Claw",
        price: "$5.50",
      },
      {
        name: "Ciderboys Cider",
        price: "$4.00",
      },
      {
        name: "Topo Chico",
        price: "$5.00",
      },
      {
        name: "Red Bull",
        price: "$4.50",
      },
      {
        name: "Red Bull Sugar Free",
        price: "$4.50",
      },
      {
        name: "Angry Orchard",
        price: "$5.50",
      },
      {
        name: "Coors Light Edge",
        price: "$4.00",
      },
      // The following items were struck out in the image, suggesting they should be removed
      // {
      //   name: "Heineken Zero",
      //   price: "$5.50",
      // },
    ],
  },
];

export default beerList;



// WEBPACK FOOTER //
// ./src/services/drinkLists/beerList.js